import { NgModule } from '@angular/core';
import { LibCircleTickIconComponent } from './lib-circle-tick-icon.component';

@NgModule({
  declarations: [LibCircleTickIconComponent],
  imports: [],
  exports: [LibCircleTickIconComponent],
})
export class LibCircleTickIconModule {}
